import Service from '@/service/index.js';
import RegExpObj from '@/utils/regExp.js';
// import Bus from '../../../../transaction-pro/bus.js';
import synthesizeFormMixins from '../mixins/synthesize-form.js';
const massifsForm = function() {
  return [
    {
      massifName: '',
      area: null,
      type: '',
      toEast: '',
      toWest: '',
      toSouth: '',
      toNorth: '',
      lastYearCrop: '',
      yearBeforeLastCrop: '',
      attachment: ''
    }
  ];
};
export default {
  mixins: [synthesizeFormMixins],
  props: ['projectInfo', 'projectSubType', 'assetsmassifs'],
  data() {
    return {
      bidGeneralSituation: 1, // 农地经营权信息
      typeArr: [],
      massifs: massifsForm(),
      rules: {
        massifName: [
          { required: true, message: '请输入地块名称', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请输入地块面积', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择地块类型', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入地块转让总价格', trigger: 'blur' }
        ],
        toEast: [
          { required: true, message: '请输入东至', trigger: 'blur' }
        ],
        toWest: [
          { required: true, message: '请输入西至', trigger: 'blur' }
        ],
        toSouth: [
          { required: true, message: '请输入南至', trigger: 'blur' }
        ],
        toNorth: [
          { required: true, message: '请输入北至', trigger: 'blur' }
        ],
        lastYearCrop: [
          { required: true, message: '请输入该地块去年种植作物', trigger: 'blur' }
        ],
        yearBeforeLastCrop: [
          { required: true, message: '请输入该地块前年种植作物', trigger: 'blur' }
        ],
        attachment: [
          { required: true, message: '请输入地上附着物', trigger: 'blur' }
        ]
      }
    };
  },
  created () {
    Service.getSelectList('MASSIF_TYPE').then(res => {
      if (res && res.code === '0') {
        this.typeArr = res.data;
      }
    });
  },
  methods: {

    // 当从别的页面切换过来时候 清空当前页面的值 如果说默认要展示当前页面 则不清空
    clear(){
      if( this.projectInfo.projectType === 1) return false;
      this.massifs = [
        {
          massifName: '',
          area: null,
          type: '',
          price: null,
          toEast: '',
          toWest: '',
          toSouth: '',
          toNorth: '',
          lastYearCrop: '',
          yearBeforeLastCrop: '',
          attachment: ''
        }
      ];
      this.totalForm = {
        sumArea: null,
        deliveryPeriod: null,
        startTime: '',
        endTime: ''
      };
      // 清空红色必填标示
      if(this.$refs['landForm']) {
        this.$refs['landForm'].resetFields();
      }
    },
    addLand () {
      this.massifs.push({
        massifName: '',
        area: null,
        type: '',
        price: null,
        toEast: '',
        toWest: '',
        toSouth: '',
        toNorth: '',
        lastYearCrop: '',
        yearBeforeLastCrop: '',
        attachment: '',
        originalContractor: '',
        certificateNo: ''
      });
    },
    deleteLand (index) {
      this.massifs.splice(index, 1);
      let sumArea = 0;
      this.massifs.forEach(item => {
        sumArea += Number(item.area);
      });
      this.totalForm.sumArea = sumArea.toFixed(2);
    },
    changeArea (event, index) {
      if (!RegExpObj.num.test(this.massifs[index].area)) {
        return;
      }
      this.massifs[index].area = this.massifs[index].area && Number(this.massifs[index].area).toFixed(2);
      let num = 0;
      this.massifs.forEach(item => {
        num += Number(item.area);
      });
      this.totalForm.sumArea = num.toFixed(2);
    }
    // test() {
    //   return new Promise((resolve, reject) => {
    //     let num = 0;
    //     this.massifs.forEach((form, index) => {
    //       this.$refs[`landForm${index}`][0].validate((valid) => {
    //         if (valid) {
    //           num ++;
    //         } else {
    //           reject();
    //         }
    //       });
    //     });
    //     if (num === this.massifs.length) {
    //       resolve({
    //         massifs: JSON.parse(JSON.stringify(this.massifs)),
    //         ...this.totalForm,
    //         bidGeneralSituation: this.bidGeneralSituation
    //       });
    //     } else {
    //       reject();
    //     }
    //   });
    // }
  }
};
